export default function AuthorBio() {
  return (
    <div className="border border-white/10 rounded-lg p-6 sm:p-8 bg-[#111111] mt-12">
      <div className="flex items-start gap-5">
        <div className="w-16 h-16 flex-shrink-0 rounded-full bg-[#c8a96e] flex items-center justify-center">
          <i className="ri-user-fill text-black text-2xl" aria-hidden="true" />
        </div>
        <div>
          <p className="text-[#c8a96e] text-xs font-bold tracking-[0.2em] uppercase mb-1">About the Author</p>
          <h3 className="text-white text-lg font-black mb-2">Mason Hale</h3>
          <p className="text-gray-400 text-sm leading-relaxed">
            Mason Hale is a 62-year-old fitness coach who lost 55 lbs and got off 3 prescription medications through his own joint-safe strength training system. After transforming his own health after 60, he created the <strong className="text-white">Over-60 Strength Blueprint</strong> to help other men do the same — without wrecking their joints or spending hours in the gym. He writes about practical, no-BS fitness strategies for men over 60.
          </p>
          <div className="flex items-center gap-4 mt-3">
            <a
              href="mailto:masonhalefit@gmail.com"
              className="text-[#c8a96e] text-xs font-semibold hover:text-[#d9bc82] transition-colors"
            >
              masonhalefit@gmail.com
            </a>
            <a
              href="https://masonhalefit.com"
              className="text-[#c8a96e] text-xs font-semibold hover:text-[#d9bc82] transition-colors"
            >
              masonhalefit.com
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}
